// src/features/legal/components/PrivacyPolicy.tsx
import React from 'react';

import './PrivacyPolicy.css';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="privacy-policy-container">
      <h1>プライバシーポリシー</h1>

      <p>
        FLUCT株式会社（以下「当社」といいます。）は、当社が提供するエンドユーザー向けアプリ「home
        karte（ホームカルテ）」及び事業者向け業務支援システム「Home
        Doctor（ホームドクター）」（以下、総称して「本サービス」といいます。）において取得する個人情報について、個人情報の保護に関する法律（平成15年法律第57号）（以下「個人情報保護法」といいます。）その他の関係法令を遵守し、以下のとおりプライバシーポリシー（以下「本ポリシー」といいます。）を定めます。
      </p>

      <h2>1. 定義</h2>
      <p>
        本ポリシー上、特段の定めがある場合を除いて、用語の定義は個人情報保護法及び本サービスの利用規約に従います。
      </p>

      <h2>2. 取得する情報</h2>
      <p>
        当社は、本サービスの提供にあたり、利用者及び事業者から以下の情報を取得します。なお、当社は、本サービスの提供にあたり、健康状態、病歴、障害の有無その他の要配慮個人情報（個人情報保護法第2条第3項）に該当する情報を取得しません。
      </p>

      <h3>(1) 利用者及び事業者から直接取得する情報</h3>
      <ul>
        <li>氏名、住所、電話番号（携帯電話番号を含む。）、メールアドレス</li>
        <li>
          利用者が工事等を依頼する物件（以下「対象物件」という。）に関する情報（住所、住宅種別、設備情報、保証情報等）
        </li>
        <li>利用者による支払い履歴及び支払い方法に関する情報</li>
        <li>問い合わせ内容、連絡履歴</li>
        <li>
          事業者の利用申込み、契約締結、サポート内容その他これらに付随する手続に関連して、提供される情報（会社名、担当者名、部署名、電話番号、メールアドレスその他の情報）
        </li>
        <li>本サービス上で入力・送信されたその他の情報</li>
      </ul>

      <h3>(2) 提携事業者から取得する情報</h3>
      <ul>
        <li>
          提携事業者が業務支援システム「Home
          Doctor」に入力した、住宅の点検・修繕履歴、見積・作業内容等に関する情報のうち、利用者の同意に基づき本サービスに表示される情報
        </li>
      </ul>

      <h3>(3) 本サービスの利用上、自動的に取得する情報</h3>
      <ul>
        <li>端末情報、OS</li>
        <li>アクセスログ、操作履歴、IPアドレス</li>
        <li>Cookie、類似技術による情報（セキュリティ確保等）</li>
      </ul>

      <h2>3. 利用目的</h2>
      <p>当社は、取得した個人情報を以下の目的の範囲内で利用します。</p>
      <ul>
        <li>本サービスの提供、運営、維持、改善</li>
        <li>利用者登録、本人確認、認証</li>
        <li>住宅点検・修繕履歴、保証情報等の管理・表示</li>
        <li>電子契約、申込手続、決済等に関する案内・連携</li>
        <li>問い合わせ対応、通知、リマインダー配信</li>
        <li>不正利用防止、セキュリティ確保</li>
        <li>法令遵守、紛争対応、権利行使・義務履行</li>
        <li>上記に付随する目的</li>
      </ul>
      <p>
        当社は、提携事業者が提供する点検等役務の営業活動・勧誘のために、利用者の個人情報を独自に利用することはありません。
      </p>

      <h2>4. Home Doctorとhome karteの情報連携</h2>
      <p>
        当社は、提携事業者がHome
        Doctorに入力した情報の一部を、本サービス上で表示又は入力補助として利用することがあり、本サービスの利用者のうちHome
        Doctorを利用する者はあらかじめこれを承諾するものとします。この際、当該情報連携は、利用者が自身の情報を確認・管理する目的に限定されます。
      </p>

      <h2>5. 第三者提供</h2>
      <p>
        当社は、次の場合を除き、利用者の個人データを第三者に提供しません。
      </p>
      <ul>
        <li>利用者の同意がある場合</li>
        <li>法令に基づく場合</li>
        <li>
          人の生命・身体・財産の保護のために必要で、同意取得が困難な場合
        </li>
        <li>
          決済・電子契約に関して個人データの提供が必要となる場合
        </li>
      </ul>
      <p>
        クレジットカード決済及び後払い等の機能については、当社が指定する第三者サービスプロバイダに必要な範囲で個人データが提供されることがあります。この場合、当該第三者サービスプロバイダが定めるプライバシーポリシー及び規約が適用されます。
      </p>

      <h2>6. 安全管理措置</h2>
      <p>
        当社は、個人情報の漏えい、滅失、毀損、不正アクセス等を防止するため、以下を含む必要かつ適切な安全管理措置を講じます。
      </p>

      <h3>(1) 組織的安全管理措置</h3>
      <ul>
        <li>
          個人情報保護管理責任者を設置し、個人データの取扱いに関する責任と権限を明確化します。
        </li>
        <li>
          法令・社内規程違反又はその兆候を把握した場合の報告・連絡体制（エスカレーション）を整備します。
        </li>
        <li>
          アクセス権限付与、委託先管理、ログ監査等について、定期的な点検・監査を実施します。
        </li>
        <li>
          漏えい等の事故発生時に備え、対応手順（初動、調査、再発防止、通知・報告）を整備します。
        </li>
      </ul>

      <h3>(2) 人的安全管理措置</h3>
      <ul>
        <li>
          個人データを取り扱う従業者に対し、個人情報保護法に関する定期的な教育・研修を実施します。
        </li>
        <li>
          従業者及び関係者に対し、個人データに関する秘密保持義務を就業規則・誓約書・契約等により課し、退職・契約終了後も有効とします。
        </li>
        <li>
          職務・役割に応じて取扱権限を付与し、異動・退職等に伴い速やかに権限を見直し／抹消します。
        </li>
        <li>
          事故・違反兆候を把握した場合の報告義務と手順を周知します。
        </li>
      </ul>

      <h3>(3) 技術的安全管理措置</h3>
      <ul>
        <li>
          職務に応じた最小権限（least
          privilege）の付与、権限管理、アクセス可能範囲の制限等のアクセス制御を実施します。
        </li>
        <li>
          個人データへのアクセス状況についてログを取得・保管し、必要に応じて監視・点検します。
        </li>
        <li>
          通信の暗号化（例：TLS）等により、通信経路上での漏えいを防止します。
        </li>
        <li>
          個人データを保存する場合、必要に応じて暗号化その他の手段により保護します（保存時暗号化等）。
        </li>
        <li>
          不正ソフトウェア対策、脆弱性対策（セキュリティパッチ適用等）を実施します。
        </li>
      </ul>

      <h2>7. 個人情報の保存期間</h2>
      <p>
        当社は、利用契約終了後も、法令上必要な場合又は当社の正当な業務目的の範囲で、一定期間保存することがあります。
      </p>

      <h2>8. 利用者の権利</h2>
      <p>
        利用者は、個人情報保護法に基づき、当社に対して、以下の請求を行うことができます。
      </p>
      <ul>
        <li>利用目的の通知</li>
        <li>開示</li>
        <li>訂正、追加、削除</li>
        <li>利用停止、消去、第三者提供の停止</li>
      </ul>
      <p>
        これらの請求を行う場合には、第10項のお問い合わせ窓口までご連絡ください。
      </p>

      <h2>9. Cookie等の利用</h2>
      <p>
        当社は、本サービスの利便性向上、利用状況分析、セキュリティ確保のため、Cookie等を使用することがあります。Cookieの詳細及び取り扱いについては以下の各号をご覧ください。
      </p>
      <ol>
        <li>
          Cookieとは利用者のウェブサイト閲覧情報を、その利用者のコンピューター（PCやスマートフォン、タブレットなどインターネット接続可能な機器）に記憶させる機能を意味します。当社は、Cookieを使用し、ウェブサイト訪問回数や訪問したページなどの閲覧情報を取得することがあります。利用者がウェブサイトを閲覧する際に、利用者のコンピューターを識別し、サービスを利用できるようにするために使用しております。利用者のコンピューター上にCookieを保存することによって、同じ情報を繰り返し入力することがなくなるなど、ブラウザ上でウェブサイトへアクセスする利便性が高まります。
        </li>
        <li>
          当社では、Cookieを使用して収集した情報を利用し、利用者のウェブサイトの利用状況（アクセス状況、トラフィック、ルーティング等）を分析し、ウェブサイト自体のパフォーマンス改善や、当社から利用者に提供するサービスの向上・改善のために使用することがあります。
        </li>
        <li>
          当社では、ウェブサイトおよび提携する広告配信サービス提供会社において、行動ターゲティング広告の配信を行う場合があります。上記の目的において、Cookieの使用を伴う第三者のサービス・ツールを利用します。第三者が提供するサービス・ツールでは、Cookieを使用して取得した情報を第三者に対し、利用者が提供した情報、または利用者が利用したサービスから収集した情報と組み合わせることがあります。利用者は、以下の方法のいずれか、もしくは両方により、Cookieの使用に関し設定を変更することが可能です。
        </li>
        <li>
          Cookie同意バナーが表示される当社ウェブサイトでは、バナー内の「Cookie
          設定」リンクより、対象のウェブサイトもしくは第三者のCookieの使用に関し、ウェブサイトの機能に必須でないCookieの許可・拒否を選択することが可能です。ただし、Cookieを拒否した場合は、対象のウェブサイトの一部のサービスが受けられない場合があることをご了承ください。
        </li>
        <li>
          利用者は、ご使用の各ブラウザの設定を変更することによって、Cookieを無効にすることが可能です。ただし、Cookieを無効にした場合は、本サービスの一部が受けられない場合があることをご了承ください。
        </li>
      </ol>

      <h2>10. お問い合わせ窓口</h2>
      <p>
        個人情報の取扱いに関するお問い合わせ、開示等の請求は、以下の窓口までご連絡ください。
      </p>
      <address>
        FLUCT株式会社 個人情報保護担当
        <br />
        E-mail：
        privacy@fluct.inc
        <br />
        住所：〒107-0062 東京都港区南青山3-1-3 SPLINE青山東急ビル6F
      </address>

      <h2>11. 本ポリシーの変更</h2>
      <p>
        当社は、法令の変更又はサービス内容の変更等に応じて、本ポリシーを改定することがあります。重要な変更を行う場合には、本サービス上で周知します。
      </p>
    </div>
  );
};

export default PrivacyPolicy;
